import { BASE_API_URL } from '../config/pathApi'

// LOGIN
export const LOGIN_FETCHING = 'LOGIN_FETCHING'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILED = 'LOGIN_FAILED'
export const LOGOUT = 'LOGOUT'

// Transaction Edit Page
export const TRANSACTION_FETCHING = 'TRANSACTION_FETCHING'
export const TRANSACTION_SUCCESS = 'TRANSACTION_SUCCESS'
export const TRANSACTION_FAILED = 'TRANSACTION_FAILED'

// staff Edit Page
export const STAFF_FETCHING = 'STAFF_FETCHING'
export const STAFF_SUCCESS = 'STAFF_SUCCESS'
export const STAFF_FAILED = 'STAFF_FAILED'

// staff Report
export const REPORT_FETCHING = 'STAFF_REPORT_FETCHING'
export const REPORT_SUCCESS = 'STAFF_REPORT_SUCCESS'
export const REPORT_FAILED = 'STAFF_REPORT_FAILED'

// Branch Edit Page
export const BRANCH_FETCHING = 'BRANCH_FETCHING'
export const BRANCH_SUCCESS = 'BRANCH_SUCCESS'
export const BRANCH_FAILED = 'BRANCH_FAILED'

// Branch Edit Page
export const BANKACCOUNT_FETCHING = 'BANKACCOUNT_FETCHING'
export const BANKACCOUNT_SUCCESS = 'BANKACCOUNT_SUCCESS'
export const BANKACCOUNT_FAILED = 'BANKACCOUNT_FAILED'

// Transaction Edit Page
export const TRANSACTION_EDIT_FETCHING = 'TRANSACTION_EDIT_FETCHING'
export const TRANSACTION_EDIT_SUCCESS = 'TRANSACTION_EDIT_SUCCESS'
export const TRANSACTION_EDIT_FAILED = 'TRANSACTION_EDIT_FAILED'
export const TRANSACTION_EDIT_INITIALED = 'TRANSACTION_EDIT_INITIALED'

// DOCUMNENT
export const DOCUMNENT_FETCHING = 'DOCUMNENT_FETCHING'
export const DOCUMNENT_SUCCESS = 'DOCUMNENT_SUCCESS'
export const DOCUMNENT_FAILED = 'DOCUMNENT_FAILED'

export const DOCUMNENT_DETAIL_FETCHING = 'DOCUMNENT_DETAIL_FETCHING'
export const DOCUMNENT_DETAIL_SUCCESS = 'DOCUMNENT_DETAIL_SUCCESS'
export const DOCUMNENT_DETAIL_FAILED = 'DOCUMNENT_DETAIL_FAILED'

//Payment Details
export const PAYMENT_DETAIL_FETCHING = 'PAYMENT_DETAIL_FETCHING'
export const PAYMENT_DETAIL_SUCCESS = 'PAYMENT_DETAIL_SUCCESS'
export const PAYMENT_DETAIL_FAILED = 'PAYMENT_DETAIL_FAILED'

// Policy Detail
export const POLICY_DETAIL_FETCHING = 'POLICY_DETAIL_FETCHING'
export const POLICY_DETAIL_SUCCESS = 'POLICY_DETAIL_SUCCESS'
export const POLICY_DETAIL_FAILED = 'POLICY_DETAIL_FAILED'

// Error Code
export const E_SET_ERROR = 'E_SET_ERROR'
export const E_RESET_ERROR = 'E_RESET_ERROR'
export const E_PICKER_CANCELLED = 'E_PICKER_CANCELLED'
export const E_PICKER_CANNOT_RUN_CAMERA_ON_SIMULATOR = 'E_PICKER_CANNOT_RUN_CAMERA_ON_SIMULATOR'
export const E_PERMISSION_MISSING = 'E_PERMISSION_MISSING'
export const E_PICKER_NO_CAMERA_PERMISSION = 'E_PICKER_NO_CAMERA_PERMISSION'
export const E_USER_CANCELLED = 'E_USER_CANCELLED'
export const E_UNKNOWN = 'E_UNKNOWN'
export const E_DEVELOPER_ERROR = 'E_DEVELOPER_ERROR'
export const TIMEOUT_NETWORK = 'ECONNABORTED' // request service timeout
export const NOT_CONNECT_NETWORK = 'NOT_CONNECT_NETWORK'

//////////////// Localization Begin ////////////////
export const NETWORK_CONNECTION_MESSAGE = 'Cannot connect to server, Please try again.'
export const NETWORK_TIMEOUT_MESSAGE = 'A network timeout has occurred, Please try again.'
export const UPLOAD_PHOTO_FAIL_MESSAGE = 'An error has occurred. The photo was unable to upload.'
export const ACCOUNT_LOCK_MESSAGE =
  'ท่านมีใบรับเงินชั่วคราวที่ยังไม่นำส่งบริษัทฯเกิน10วัน ส่งผลให้ท่านถูกระงับผลประโยชน์ และระงับสิทธิ์ในการออกใบรับเงินชั่วคราว จนกว่าจะนำส่งเรียบร้อย'

export const AGING_MESSAGE = `ท่านมีใบรับเงินชั่วคราวที่ยังไม่นำส่งบริษัทฯ กรุณาตรวจสอบ หากเกิน 10 วัน 
  ท่านจะไม่สามารถเข้าใช้งาน eTR system ได้ พร้อมทั้งจะถูกระงับผลประโยชน์
  จนกว่าจะนำส่งเรียบร้อย`

export const SQD_REPORT = {
  AGING_REPORT: 'AGING_REPORT',
  ETR_REPORT: 'ETR_REPORT'
}

export const ETR_STAFF_ROLES = {
  BRANCHSTAFFADMIN: 'BranchStaffAdmin',
  BRANCHSTAFF: 'BranchStaff',
  COLLECTIONADMIN: 'CollectionAdmin',
  COLLECTIONSTAFF: 'CollectionStaff',
  SQDADMIN: 'SQDStaffAdmin',
  SQDSTAFF: 'SQDStaff'
}

enum ETR_USER_TYPE {
  BRANCH_STAFF,
  COLLECTION,
  SQD,
  AGENT,
  AGENT_AO
}

export const ETR_STATUS = {
  NEW_ETR: 'New_ETR',
  RESEND_ETR: 'Resend_ETR',
  CANCEL_ETR: 'Cancel_ETR',
  SUCCESS_ETR: 'Success_ETR',
  SUBMITED_ETR: 'Submitted_ETR'
}

export const ETR_STATUS_THAI = [
  { id: 'New_ETR', Desc: 'รายการใหม่' },
  { id: 'Resend_ETR', Desc: 'ส่งซ้ำ' },
  { id: 'Cancel_ETR', Desc: 'ยกเลิก' },
  { id: 'Success_ETR', Desc: 'นำส่งบริษัทสำเร็จ' },
  { id: 'Submitted_ETR', Desc: 'รอดำเนินการ' }
]

export const MESSAGE_TYPE = {
  EMAIL: 'email',
  SMS: 'sms'
}

export const UL_PREFIX = ['T6', 'U2', 'U8', 'U3']

export const BILLING_FREQUENCY = [
  { id: '01', Desc: 'ปี' },
  { id: '02', Desc: '6 เดือน' },
  { id: '04', Desc: '3 เดือน' },
  { id: '12', Desc: 'เดือน' },
  { id: 'DY', Desc: 'รายวัน' },
  { id: 'WK', Desc: 'รายสัปดาห์' },
  { id: '00', Desc: 'ชำระครั้งเดียว' },
  { id: '03', Desc: '3 ปี' },
  { id: '05', Desc: '5 ปี' }
]

export const server = {
  LOGIN_URL: `login`,
  FWD_STAFF_LOGIN_URL: `staffLogin`,
  LOGOUT_URL: `logout`,
  REFRESH_TOKEN_URL: `refresh/token`,
  TRANSACTION_URL: `document`,
  MESSAGE_URL: `message`,
  TOKEN_KEY: `token`,
  REFRESH_TOKEN_KEY: `refresh_token`,
  DOWNLOAD_DOCUMENT_URL: `getDocument`,
  BRANCH: 'branch',
  INFO: 'info',
  POLICY: 'policy',
  STAFF: `staff`,
  SEARCH_STAFF: `searchStaff`,
  STAFF_REPORT: 'getStaffReport',
  AGING_REPORT: 'getAgingReport',
  ETR_REPORT: 'getETRReport',
  PAYMENT_DETAIL_URL: `documentDetail`,
  RECEIPT: `receipt`,
  BASE_URL: BASE_API_URL,
  MASTER_DATA: 'masterData'
  // process.env.REACT_APP_ENV === 'local'
  //   ? 'http://localhost:4000/'
  //   : process.env.REACT_APP_ENV === 'local-sit'
  //   ? 'http://localhost:8080/api/'
  //   : 'https://etr.sit.fwd.co.th/api/'
}

export const PAYMENTMODE = {
  CASH: 'CASH',
  CASHPAYIN: 'CASHPAYIN',
  CC: 'CC',
  CKC: 'CKC',
  CKCPAYIN: 'CKCPAYIN',
  FWDCKC: 'FWDCKC',
  QRCODE: 'QRCODE'
}

//BANKS
export const BANKS = JSON.parse(
  `[ { "BANKCD": "002", "BANKNAME": "ธ. กรุงเทพ จำกัด (มหาชน)", "BANKNAME_TH": "ธ. กรุงเทพ จำกัด (มหาชน)", "BANKSHORTNAME": "BBL" }, { "BANKCD": "004", "BANKNAME": "ธ. กสิกรไทย จำกัด (มหาชน)", "BANKNAME_TH": "ธ. กสิกรไทย จำกัด (มหาชน)", "BANKSHORTNAME": "KBANK" }, { "BANKCD": "006", "BANKNAME": "ธ. กรุงไทย จำกัด (มหาชน)", "BANKNAME_TH": "ธ. กรุงไทย จำกัด (มหาชน)", "BANKSHORTNAME": "KTB" }, { "BANKCD": "007", "BANKNAME": "แสตนดาร์ดชาร์เตอร์ด", "BANKNAME_TH": "แสตนดาร์ดชาร์เตอร์ด", "BANKSHORTNAME": "SCBT" }, { "BANKCD": "011", "BANKNAME": "ธนาคารทหารไทยธนชาต จำกัด (มหาชน)", "BANKNAME_TH": "ธนาคารทหารไทยธนชาต จำกัด (มหาชน)", "BANKSHORTNAME": "TTB" }, { "BANKCD": "014", "BANKNAME": "ธ. ไทยพาณิชย์ จำกัด (มหาชน)", "BANKNAME_TH": "ธ. ไทยพาณิชย์ จำกัด (มหาชน)", "BANKSHORTNAME": "SCB" }, { "BANKCD": "017", "BANKNAME": "ธ. ซิตี้แบงก์ เอ็น.เอ.", "BANKNAME_TH": "ธ. ซิตี้แบงก์ เอ็น.เอ.", "BANKSHORTNAME": "CTB" }, { "BANKCD": "022", "BANKNAME": "ธ. ซีไอเอ็มบี ไทย จำกัด (มหาชน)", "BANKNAME_TH": "ธ. ซีไอเอ็มบี ไทย จำกัด (มหาชน)", "BANKSHORTNAME": "CIMB" }, { "BANKCD": "024", "BANKNAME": "ธ. ยูโอบี จำกัด (มหาชน)", "BANKNAME_TH": "ธ. ยูโอบี จำกัด (มหาชน)", "BANKSHORTNAME": "UOB" }, { "BANKCD": "025", "BANKNAME": "ธ. กรุงศรีอยุธยา จำกัด (มหาชน)", "BANKNAME_TH": "ธ. กรุงศรีอยุธยา จำกัด (มหาชน)", "BANKSHORTNAME": "BAY" }, { "BANKCD": "030", "BANKNAME": "ธ. ออมสิน", "BANKNAME_TH": "ธ. ออมสิน", "BANKSHORTNAME": "GSB" }, { "BANKCD": "032", "BANKNAME": "ธ. ดอยซ์แบงก์", "BANKNAME_TH": "ธ. ดอยซ์แบงก์", "BANKSHORTNAME": "DB" }, { "BANKCD": "033", "BANKNAME": "ธ. อาคารสงเคราะห์", "BANKNAME_TH": "ธ. อาคารสงเคราะห์", "BANKSHORTNAME": "GHB" }, { "BANKCD": "066", "BANKNAME": "ธ. อิสลามแห่งประเทศไทย", "BANKNAME_TH": "ธ. อิสลามแห่งประเทศไทย", "BANKSHORTNAME": "IB" }, { "BANKCD": "067", "BANKNAME": "ธ. ทิสโก้ จำกัด (มหาชน)", "BANKNAME_TH": "ธ. ทิสโก้ จำกัด (มหาชน)", "BANKSHORTNAME": "TISC" }, { "BANKCD": "069", "BANKNAME": "ธ. เกียรตินาคิน จำกัด (มหาชน)", "BANKNAME_TH": "ธ. เกียรตินาคิน จำกัด (มหาชน)", "BANKSHORTNAME": "KK" }, { "BANKCD": "070", "BANKNAME": "ธ. ไอซีบีซี (ไทย) จำกัด (มหาชน)", "BANKNAME_TH": "ธ. ไอซีบีซี (ไทย) จำกัด (มหาชน)", "BANKSHORTNAME": "ACL" }, { "BANKCD": "073", "BANKNAME": "ธ. แลนด์ แอนด์ เฮ้าส์ จำกัด (มหาชน)", "BANKNAME_TH": "ธ. แลนด์ แอนด์ เฮ้าส์ จำกัด (มหาชน)", "BANKSHORTNAME": "LHB" }, { "BANKCD": "071", "BANKNAME": "ธ. ไทยเครดิต เพื่อรายย่อย จำกัด (มหาชน)", "BANKNAME_TH": "ธ. ไทยเครดิต เพื่อรายย่อย จำกัด (มหาชน)", "BANKSHORTNAME": "TCRB" }, { "BANKCD": "034", "BANKNAME": "ธ. เพื่อการเกษตรและสหกรณ์การเกษตร", "BANKNAME_TH": "ธ. เพื่อการเกษตรและสหกรณ์การเกษตร", "BANKSHORTNAME": "BAA" }, { "BANKCD": "001", "BANKNAME": "ธนาคารแห่งประเทศไทย", "BANKNAME_TH": "ธนาคารแห่งประเทศไทย", "BANKSHORTNAME": "BOT" }, { "BANKCD": "008", "BANKNAME": "ธ. เจพีมอร์แกน เชส", "BANKNAME_TH": "ธ. เจพีมอร์แกน เชส", "BANKSHORTNAME": "JPMC" }, { "BANKCD": "009", "BANKNAME": "ธ. โอเวอร์ซี-ไชนีสแบงกิ้งคอร์ปอเรชั่น จำกัด", "BANKNAME_TH": "ธ. โอเวอร์ซี-ไชนีสแบงกิ้งคอร์ปอเรชั่น จำกัด", "BANKSHORTNAME": "OCBC" }, { "BANKCD": "018", "BANKNAME": "ธ. ซูมิโตโม มิตซุย แบงกิ้ง คอร์ปอเรชั่น", "BANKNAME_TH": "ธ. ซูมิโตโม มิตซุย แบงกิ้ง คอร์ปอเรชั่น", "BANKSHORTNAME": "SMBC" }, { "BANKCD": "020", "BANKNAME": "ธ. สแตนดาร์ดชาร์เตอร์ด (ไทย) จำกัด (มหาชน)", "BANKNAME_TH": "ธ. สแตนดาร์ดชาร์เตอร์ด (ไทย) จำกัด (มหาชน)", "BANKSHORTNAME": "SCBT" }, { "BANKCD": "023", "BANKNAME": "ธ. อาร์ เอช บี จำกัด", "BANKNAME_TH": "ธ. อาร์ เอช บี จำกัด", "BANKSHORTNAME": "RHB" }, { "BANKCD": "026", "BANKNAME": "ธ. เมกะ สากลพาณิชย์ จำกัด (มหาชน)", "BANKNAME_TH": "ธ. เมกะ สากลพาณิชย์ จำกัด (มหาชน)", "BANKSHORTNAME": "ICBCT" }, { "BANKCD": "027", "BANKNAME": "ธ. แห่งอเมริกาเนชั่นแนลแอสโซซิเอชั่น", "BANKNAME_TH": "ธ. แห่งอเมริกาเนชั่นแนลแอสโซซิเอชั่น", "BANKSHORTNAME": "BA" }, { "BANKCD": "029", "BANKNAME": "ธ. อินเดียนโอเวอร์ซีส์", "BANKNAME_TH": "ธ. อินเดียนโอเวอร์ซีส์", "BANKSHORTNAME": "IOB" }, { "BANKCD": "031", "BANKNAME": "ธ. ฮ่องกงและเซี่ยงไฮ้แบงกิ้งคอร์ปอเรชั่น จำกัด", "BANKNAME_TH": "ธ. ฮ่องกงและเซี่ยงไฮ้แบงกิ้งคอร์ปอเรชั่น จำกัด", "BANKSHORTNAME": "HSBC" }, { "BANKCD": "035", "BANKNAME": "ธ. เพื่อการส่งออกและนำเข้าแห่งประเทศไทย", "BANKNAME_TH": "ธ. เพื่อการส่งออกและนำเข้าแห่งประเทศไทย", "BANKSHORTNAME": "EXIM" }, { "BANKCD": "039", "BANKNAME": "ธ. มิซูโฮ จำกัด สาขากรุงเทพฯ", "BANKNAME_TH": "ธ. มิซูโฮ จำกัด สาขากรุงเทพฯ", "BANKSHORTNAME": "MHCB" }, { "BANKCD": "045", "BANKNAME": "ธ. บีเอ็นพี พารีบาส์", "BANKNAME_TH": "ธ. บีเอ็นพี พารีบาส์", "BANKSHORTNAME": "NBP" }, { "BANKCD": "052", "BANKNAME": "ธ. แห่งประเทศจีน (ไทย) จำกัด (มหาชน)", "BANKNAME_TH": "ธ. แห่งประเทศจีน (ไทย) จำกัด (มหาชน)", "BANKSHORTNAME": "BOC" }, { "BANKCD": "079", "BANKNAME": "ธ. เอเอ็นแซด (ไทย) จำกัด (มหาชน)", "BANKNAME_TH": "ธ. เอเอ็นแซด (ไทย) จำกัด (มหาชน)", "BANKSHORTNAME": "ANZB" }, { "BANKCD": "080", "BANKNAME": "ธ. ซูมิโตโม มิตซุย ทรัสต์ (ไทย) จำกัด (มหาชน)", "BANKNAME_TH": "ธ. ซูมิโตโม มิตซุย ทรัสต์ (ไทย) จำกัด (มหาชน)", "BANKSHORTNAME": "STBC" }, { "BANKCD": "093", "BANKNAME": "บรรษัทประกันสินเชื่ออุตสาหกรรมขนาดย่อม", "BANKNAME_TH": "บรรษัทประกันสินเชื่ออุตสาหกรรมขนาดย่อม", "BANKSHORTNAME": "TCG" }, { "BANKCD": "096", "BANKNAME": "บรรษัทตลาดรองสินเชื่อที่อยู่อาศัย", "BANKNAME_TH": "บรรษัทตลาดรองสินเชื่อที่อยู่อาศัย", "BANKSHORTNAME": "SMC" }, { "BANKCD": "098", "BANKNAME": "ธ. พัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย", "BANKNAME_TH": "ธ. พัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย", "BANKSHORTNAME": "SME" } ]`
)

//CreditCard_holder_relationship
export const CARD_HOLDER_RELATIONSHIPS = JSON.parse(
  `[ { "code": "027", "name": "ตนเอง" }, { "code": "001", "name": "บิดา" }, { "code": "002", "name": "มารดา" }, { "code": "003", "name": "คู่สมรส" }, { "code": "004", "name": "บุตร" }, { "code": "009", "name": "บุตรบุญธรรมตามกฎหมาย" }, { "code": "020", "name": "บิดาบุญธรรม" }, { "code": "021", "name": "มารดาบุญธรรม" }, { "code": "005", "name": "ปู่" }, { "code": "006", "name": "ย่า" }, { "code": "007", "name": "ตา" }, { "code": "008", "name": "ยาย" }, { "code": "022", "name": "พี่ร่วมบิดาและมารดาเดียวกัน" }, { "code": "023", "name": "น้องร่วมบิดาและมารดาเดียวกัน" }, { "code": "024", "name": "พี่ร่วมบิดาหรือมารดาเดียวกัน" }, { "code": "025", "name": "น้องร่วมบิดาหรือมารดาเดียวกัน" }, { "code": "017", "name": "พี่" }, { "code": "018", "name": "น้อง" }, { "code": "014", "name": "หลาน" }, { "code": "010", "name": "ลุง" }, { "code": "011", "name": "ป้า" }, { "code": "012", "name": "น้า" }, { "code": "013", "name": "อา" }, { "code": "026", "name": "บริษัท" }, { "code": "019", "name": "อื่นๆ โปรดระบุ..." }, { "code": "028", "name": "กองมรดก" }, { "code": "029", "name": "คู่ชีวิต" }, { "code": "030", "name": "ลูกพี่ลูกน้อง" } ]`
)

export const MONEY_TYPE = {
  CASH: 'Cash',
  CASH_PAY_IN: 'Cash pay in',
  CREDIT_CARD: 'CC',
  CKC: 'CKC',
  CKC_PAY_IN: 'CKC pay in',
  FWD_CKC: 'FWD CKC',
  QR_CODE: 'QR Code'
}

export const PAYMENT_METHOD_ID = {
  CASH: '1',
  CKC: '2',
  CREDIT_CARD: '3',
  OTHER: '4',
  CASH_PAY_IN: '5',
  CKC_PAY_IN: '6',
  FWD_CKC: '7',
  QR_CODE: '8'
}

export const PAYMENT_METHOD_NAME = {
  CASH: 'เงินสด',
  CKC: 'เช็คธนาคาร',
  CREDIT_CARD: 'บัตรเครดิต',
  OTHER: 'อื่นๆ',
  CASH_PAY_IN: 'Cash pay in',
  CKC_PAY_IN: 'CKC pay in',
  FWD_CKC: 'FWD CKC',
  QR_CODE: 'QR Code'
}

export const mockPaymentDetail = {
  created: '2024-04-13T02:51:32.755Z',
  createBy: null,
  updated: '2024-04-13T02:51:32.000Z',
  updateBy: null,
  id: 196988,
  paymentType: '',
  paymentAmount: '6.00',
  cheque_Bank: '',
  cheque_Branch: '',
  cheque_Number: 'FWD00001',
  cheque_Date: '2024-04-06',
  creditCard_HolderName: '',
  creditCard_Type: '',
  creditCard_Number: '',
  creditCard_Number_data: null,
  creditCard_ExpDate: '',
  other_Pay: '',
  payInToBank: null,
  accountNo: null,
  payInDate: '2024-04-12',
  creditCard_Fee: null,
  creditCard_SignDate: null,
  creditCard_ApprovalCode: null,
  creditCard_ApprovalDate: null,
  creditCard_HolderRelationship: null,
  remarkMoneyType: null,
  payInSlipDate: null,
  cheque_TotalAmount: null,
  bankName: null,
  bankCode: null,
  cheque_BankCode: null,
  cheque_Branchcode: null,
  paymentMethod: {
    created: '2024-04-07T19:42:02.000Z',
    createBy: 'admin',
    updated: '2024-04-13T02:58:50.057Z',
    updateBy: 'admin',
    id: 7,
    name: 'FWD CKC',
    description: 'FWD CKC',
    orderBy: 6
  }
}

export const targetPayInToBank = 'payInToBank'
export const targetBankCode = 'bankCode'
//PAYMENT_MEHOD
export const PAYMENT_MEHOD = JSON.parse(
  '[ { "id" : 1, "name" : "เงินสด", "description" : "เงินสด", "code" : "CASH" }, { "id" : 2, "name" : "เช็คธนาคาร", "description" : "เช็คธนาคาร", "code" : "CKC" }, { "id" : 3, "name" : "บัตรเครดิต", "description" : "บัตรเครดิต", "code" : "CC" }, { "id" : 4, "name" : "อื่นๆ", "description" : "อื่นๆ", "code" : "OTHER" }, { "id" : 5, "name" : "โอนเงินสดเข้าบัญชีธนาคาร", "description" : "โอนเงินสดเข้าบัญชีธนาคาร", "code" : "CASHPAYIN" }, { "id" : 6, "name" : "นำเช็คเข้าบัญชีธนาคาร", "description" : "นำเช็คเข้าบัญชีธนาคาร", "code" : "CKCPAYIN" }, { "id" : 7, "name" : "เช็คสั่งจ่ายโดย FWD", "description" : "เช็คสั่งจ่ายโดย FWD", "code" : "FWDCKC" }, { "id" : 8, "name" : "QR Code", "description" : "QR Code", "code" : "QRCODE" } ]'
)
